import { render, staticRenderFns } from "./EditVtsCenterPractice.vue?vue&type=template&id=1492eced"
import script from "./EditVtsCenterPractice.vue?vue&type=script&lang=ts"
export * from "./EditVtsCenterPractice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports